import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

export default class Despacho extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                id: this.props.match.params.id,
                user: localStorage.nome,
                name: '',
                tipoDoc: '',
                tipo: '',
            },
            button: false
        }
    }

    updateField(e) {
        let file = e.target.files[0]
        this.setState({ file: file })
    }

    updateName(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    save(e) {
        e.preventDefault()

        this.setState({ button: true })

        const url = '/api/anexos/posts'
        var paf = this.props.location.search.slice(1)
        const ficha = { ...this.state.ficha }
        ficha.tipo = paf
        this.setState({ ficha })

        const formData = new FormData()
        formData.append("file", this.state.file)
        formData.append("id", this.state.ficha.id)
        formData.append("user", this.state.ficha.user)
        formData.append("name", this.state.ficha.name)
        formData.append("tipo", paf)
        formData.append("tipoDoc", this.state.ficha.tipoDoc)
        axios.post(url, formData)
            .then(res => {
                alert(res.data)
                if (this.state.ficha.tipo == 'paf') {
                    window.location = `/documentosPaf/${this.state.ficha.id}`
                } else {
                    window.location = `/documentos/${this.state.ficha.id}`
                }
            })
            .catch(error => {
                alert(error.response.data)
                this.setState({ button: false })
            })
    }

    render() {
        return (
            <div className="container mx-auto text-center">
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2vh" }}>
                    <div style={{
                        textAlign: "left", color: "#484848",
                        marginRight: "2vw"
                    }}>
                        <div>Tipo de Documento:</div>
                        <input type="text" name="tipoDoc" onChange={e => this.updateName(e)}
                            style={{
                                width: "25vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                                borderRadius: "5px", minHeight: "5px"
                            }} />
                        <div>Nome para o arquivo:</div>
                        <input type="text" name="name" onChange={e => this.updateName(e)}
                            style={{
                                width: "25vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                                borderRadius: "5px", minHeight: "5px"
                            }} />
                        <input type="file" className="form-control-file" name="file" style={{marginTop: "2vh"}}
                            onChange={e => this.updateField(e)} />
                    </div>
                </div>
                <Button onClick={e => this.save(e)} disabled={this.state.button} />
            </div>

        )
    }
}